var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1,16.3c-0.3-0.4-1.1-1.6-1.3-2.7c-0.3-1.5-0.2-3.6-0.2-3.6c0,0,0,0,0,0c0-3.1-2.5-5.6-5.6-5.6 c-3.1,0-5.6,2.5-5.6,5.6h0c0,0,0,0,0,0c0,0,0,2.1-0.2,3.6c-0.3,1.3-1.3,2.7-1.3,2.7c-0.3,0.3-0.2,0.8,0.1,1.1 c0.1,0.1,0.3,0.2,0.5,0.2h4.4c0.1,1.1,1.1,1.9,2.2,1.9s2.1-0.9,2.2-1.9h4.1v0c0,0,0.1,0,0.1,0c0.2,0,0.3-0.1,0.5-0.2 C19.3,17.1,19.3,16.7,19.1,16.3z M12,6c2.2,0,4.1,1.8,4.1,4.1h0c0,0.1,0,2.3,0.3,3.9c0.1,0.8,0.5,1.5,0.8,2.1H14l0,0l-3.8,0H6.9 c0.3-0.6,0.6-1.3,0.8-2.1c0.3-1.6,0.3-3.7,0.3-3.9C7.9,7.8,9.8,6,12,6z M12.1,18c-0.3,0-0.6-0.2-0.7-0.4h1.3 C12.6,17.8,12.4,18,12.1,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.560df791e93a1f46006f6db80fe7a90f.svg";
export { ForwardRef as ReactComponent };